import { PatientAttachment } from '../Attachment';
import React, { useEffect } from 'react';
import { useNotify } from '../../../../../../hooks';
import { DotLoader } from '@lifeomic/chroma-react/components/DotLoader';
import _noop from 'lodash/noop';
import { Modal } from '@lifeomic/chroma-react/components/Modal';
import { useModalStyles } from './styles';
import PatientDataCollection from '../../../../../PatientDataCollection';
import { Box } from '@lifeomic/chroma-react/components/Box';
import { defineMessages, useIntl } from 'react-intl';
import useFhirSearch, {
  Hits,
} from '../../../../../Surveys/util/FhirSearch/useFhirSearch';

const messages = defineMessages({
  patientError: {
    id: 'phc-web-toolkit.subjectViewer.executiveSummary.documentReferenceModal.patientError',
    defaultMessage: 'Error loading patient record',
  },
});

type PatientViewModalProps = {
  attachment: PatientAttachment;
  onDismiss: () => void;
};

export const PatientViewModal = (props: PatientViewModalProps) => {
  const { attachment, onDismiss } = props;
  const classes = useModalStyles();
  const { formatMessage } = useIntl();
  const [notify] = useNotify();

  const [response, isLoading] = useFhirSearch<Hits<fhir.Patient>>({
    type: 'select',
    columns: '*',
    from: [{ table: 'patient' }],
    limit: [
      { type: 'number', value: 0 },
      { type: 'number', value: 1 },
    ],
    where: {
      type: 'elasticsearch',
      query: {
        bool: {
          must: [
            {
              term: {
                'id.keyword': attachment.resource.id,
              },
            },
          ],
        },
      },
    },
  });

  const patient = response?.hits?.hits[0]?._source;

  const hasError = !isLoading && !patient;

  useEffect(() => {
    if (hasError) {
      notify(formatMessage(messages.patientError), 'error');
      onDismiss();
    }
  }, [hasError, notify, formatMessage, onDismiss]);

  return (
    <Modal
      isFullScreen
      isOpen={true}
      onDismiss={onDismiss}
      contentClassName={classes.modalContent}
      data-testid="patient-view-modal"
    >
      {isLoading ? (
        <Box fullWidth fullHeight justify="center" align="center">
          <DotLoader />
        </Box>
      ) : (
        <Box paddingTop={3} paddingBottom={5}>
          {!!patient && (
            <PatientDataCollection
              onPatientUpdate={_noop}
              patient={patient}
              disableUpdates={true}
              textFieldProps={{ readOnly: true, fullWidth: true }}
              overrideMaskedMode={true}
            />
          )}
        </Box>
      )}
    </Modal>
  );
};
